export type HeroCarouselSlideType =
  | 'hackathons'
  | 'events'
  | 'empowering_careers'
  | 'success_stories'
  | 'expert_mentors'
  | 'custom';

export type HeroCarouselCustomVariant = 'default' | 'featured';

export interface HeroCarouselCustomSlide {
  title: string;
  subtitle: string;
  primaryCta: string;
  primaryCtaLink: string;
  secondaryCta: string;
  secondaryCtaLink: string;
  /** Use [[text]] in title to highlight in brand color. */
  variant?: HeroCarouselCustomVariant;
  /** Optional pill badge above title (featured style). */
  badge?: string;
}

export interface HeroCarouselSlideItem {
  id: string;
  type: HeroCarouselSlideType;
  enabled: boolean;
  custom?: HeroCarouselCustomSlide;
}

export const DEFAULT_HERO_CAROUSEL_ORDER: HeroCarouselSlideItem[] = [
  { id: 'slide-hackathons', type: 'hackathons', enabled: true },
  { id: 'slide-events', type: 'events', enabled: true },
  { id: 'slide-empowering', type: 'empowering_careers', enabled: true },
  { id: 'slide-success', type: 'success_stories', enabled: true },
  { id: 'slide-mentors', type: 'expert_mentors', enabled: true },
];

const BUILTIN_TYPES: HeroCarouselSlideType[] = [
  'hackathons',
  'events',
  'empowering_careers',
  'success_stories',
  'expert_mentors',
];

export const HERO_CAROUSEL_TYPE_LABELS: Record<HeroCarouselSlideType, string> = {
  hackathons: 'Hackathons (enable “Show on Home Carousel” in Hackathon admin)',
  events: 'Events (enable “Show on Home Carousel” in Event admin)',
  empowering_careers: 'Empowering Careers',
  success_stories: 'Success Stories',
  expert_mentors: 'Expert Mentors',
  custom: 'Custom slide',
};

export function normalizeHeroCarouselOrder(
  stored?: HeroCarouselSlideItem[] | null
): HeroCarouselSlideItem[] {
  if (!Array.isArray(stored) || stored.length === 0) {
    return JSON.parse(JSON.stringify(DEFAULT_HERO_CAROUSEL_ORDER)) as HeroCarouselSlideItem[];
  }

  const result = stored
    .filter((item) => item && typeof item === 'object' && item.type)
    .map((item) => ({
      ...item,
      id: item.id || `slide-${item.type}-${Math.random().toString(36).slice(2, 8)}`,
      enabled: item.enabled !== false,
    }));

  for (const type of BUILTIN_TYPES) {
    if (!result.some((s) => s.type === type)) {
      result.push({
        id: `slide-${type}`,
        type,
        enabled: true,
      });
    }
  }

  return result;
}

export function createCustomCarouselSlide(): HeroCarouselSlideItem {
  return {
    id: `custom-${Date.now()}`,
    type: 'custom',
    enabled: true,
    custom: {
      title: 'New Carousel Slide',
      subtitle: '',
      primaryCta: 'Learn More',
      primaryCtaLink: '/register',
      secondaryCta: '',
      secondaryCtaLink: '',
      variant: 'featured',
      badge: '',
    },
  };
}
